
import { PerfilConfig } from "@/core/config/PerfisConfig";
import SiteUtils from '@/assets/ts/aplicacao/site';
import KDataTable from "@/components/datatable/newdatatable.vue";
import { Options, Vue } from "vue-class-component";
import { Prop } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import CardRh from "@/components/cards/ManzaCard.vue";
import AulaDisciplinaService from "@/service/v1/sigap/AulaDisciplinaService";

const authStore = namespace('auth');

@Options({
    name: "InserirFaltaMatricula",
    components: { CardRh, KDataTable },
})
export default class InserirFaltaMatricula extends Vue {
    @Prop() readonly turma!: any;

    @authStore.Getter
    public perfis!: any;

    public config: any;
    public service = new AulaDisciplinaService();
    public processando = false;
    public reloadDatatable = false;
    public search = '';
    public pelotao = '';
    public disciplinaFiltro = '';

    get hasPermissao(): boolean {
        return SiteUtils.hasPermissao([PerfilConfig.Admin, PerfilConfig.ChefeSTE, PerfilConfig.AuxSTE], this.perfis);
    }

    public refreshTable() {
        setTimeout(() => {
            this.reloadDatatable = !this.reloadDatatable;
        }, 300);
    }

    public apertouEnter(e) {
        if (e.key === 'Enter' || e.keyCode === 13) {
            this.refreshTable();
        }
    }

    public limparFiltros() {
        this.search = '';
        this.pelotao = '';
        this.disciplinaFiltro = '';
        this.refreshTable();
    }

    created() {
        this.config = { ajax: {}, columns: [], columnDefs: [], order: [] };
        this.config.ajax = {
            url: this.service.getApiUrl() + '/Relatorio/Aula',
            data: (d) => {
                const dados = {
                    Skip: d.start,
                    Take: d.length,
                    turmaId: this.turma?.id,
                    disciplina: this.disciplinaFiltro,
                    pelotao: this.pelotao,
                    search: this.search,
                };
                return dados;
            }
        }; 
        this.config.columns = [
            { data: 'disciplina', name: 'disciplina',  orderable: false },
            { data: 'pelotao', name: 'pelotao', class: 'text-center',  orderable: false  },
            { data: 'count', name: 'count', class: 'text-center',  orderable: false  },
            { data: 'cargaHoraria', name: 'cargaHoraria', class: 'text-center',  orderable: false  },
        ];
    }
}
